
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evm/welcome/accounts",
      function () {
        return require("private-next-pages/evm/welcome/accounts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evm/welcome/accounts"])
      });
    }
  